export default function Maintenance() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>🔧</div>
        <h1 style={styles.heading}>We'll be back soon</h1>
        <div style={styles.divider}></div>
        <p style={styles.text}>
          Our website is temporarily unavailable while we make some
          improvements.
        </p>
        <p style={styles.subtext}>Thank you for your patience.</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#000",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1.5rem",
    fontFamily: "system-ui, -apple-system, sans-serif",
  },
  card: {
    maxWidth: "480px",
    textAlign: "center",
  },
  iconWrap: {
    fontSize: "2.5rem",
    marginBottom: "1.5rem",
  },
  heading: {
    fontSize: "2rem",
    fontWeight: 700,
    marginBottom: "0.75rem",
  },
  divider: {
    width: "64px",
    height: "3px",
    backgroundColor: "#f4a300",
    margin: "0 auto 1.5rem",
    borderRadius: "9999px",
  },
  text: {
    fontSize: "1rem",
    color: "#d1d5db",
    lineHeight: 1.6,
    marginBottom: "0.5rem",
  },
  subtext: {
    fontSize: "0.95rem",
    color: "#9ca3af",
    lineHeight: 1.6,
  },
};
